import * as React from "react";
import { Flex, FlexItem, Grid, Skeleton, Segment, Card, Box } from "@fluentui/react-northstar";
const _ = require('lodash');
import "../loaders/loader.scss";
import "../loaders/loaderPainel.scss";

/** Component for displaying loading component. */
const Loader = (): JSX.Element => {
    return (
        <div className="main-component">
            <div className={"form-container"}>
                <Skeleton animation="pulse">
                    <Flex gap="gap.large" space="between">
                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    className="visao-geral-atendimentos"
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(30rem, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    className="visao-geral-atendimentos"
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(35rem, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.half">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>
                    </Flex>

                    <Flex
                        space="between"
                        styles={{
                            position: "sticky",
                            top: 0,
                            padding: "1.25rem 1.25rem 0.8rem 1.25rem",
                            margin: "1.25rem 0",
                            zIndex: 999,
                        }}>
                        <Flex
                            gap="gap.small"
                            styles={{
                                width: "100%"
                            }}
                        >
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                        </Flex>
                    </Flex>

                    <Flex space="between" styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                        <Flex gap="gap.small"
                            space="between"
                            className="toolbar-acesso-rapido"
                            styles={{
                                position: "sticky",
                                top: 0,
                                margin: "1.5rem 0",
                                zIndex: 1,
                            }}>
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                        <Flex gap="gap.medium" vAlign="center">
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "20rem" }} />
                            </FlexItem>
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                    </Flex>

                    <div className="form-content-container" >
                        <Grid columns="1.1fr 0.5fr 0.5fr 0.3fr 0.2fr">
                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>
                            {/*
                            <Flex gap="gap.small">
                                <FlexItem>
                                    <Text className="margin-style" content="Fila de Atendimentos" />
                                </FlexItem>
                                <FlexItem>
                                    <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content="Fila de Atendimentos" />
                                </FlexItem>
                            </Flex>
                            */}

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            {/* LIST ITEMS */}
                            {_.times(5, (index: number) => (
                                <React.Fragment key={index}>
                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>
                                </React.Fragment>
                            ))}

                        </Grid>
                    </div>
                </Skeleton>
            </div>
        </div>
    );
};

export default Loader;